export default "__VITE_ASSET__BSVp83vA__"